const getToken = () => {
  if (typeof window !== 'undefined') {
    return localStorage.getItem('token');
  }
  return null;
};

// NEUE HELPER-FUNKTION: Hole die aktuelle Sprache aus localStorage
const getCurrentLanguage = () => {
  if (typeof window !== 'undefined' && window.localStorage) {
    const lang = localStorage.getItem('selectedLanguage') || 'de';
    console.log('getCurrentLanguage() called, returning: ', lang);
    return lang;
  }
  return 'de';
};

// src/api/client.js
const API_BASE = process.env.REACT_APP_API_BASE || "https://app.fintogo.ai/api";
//const API_BASE = process.env.REACT_APP_API_BASE || "http://localhost:4000/api";

function authHeaders() {
  const t = localStorage.getItem("token");
  return t ? { Authorization: `Bearer ${t}` } : {};
}

/* ========== Auth/Me ========== */
export async function getMe() {
  const res = await fetch(`${API_BASE}/users/me`, {
    headers: { ...authHeaders() },
  });
  if (!res.ok) return null;
  return res.json();
}

/* ========== Lessons ========== */
export async function getLessons() {
  const res = await fetch(`${API_BASE}/lessons`, {
    headers: { ...authHeaders() },
  });
  if (!res.ok) throw new Error(`http_${res.status}`);
  return res.json();
}

export async function getLessonProgress(userId) {
  const res = await fetch(
    `${API_BASE}/lesson-progress?user_id=${encodeURIComponent(userId)}`,
    { headers: { ...authHeaders() } }
  );
  if (!res.ok) throw new Error(`http_${res.status}`);
  return res.json();
}

export async function upsertLessonProgress(payload) {
  const res = await fetch(`${API_BASE}/lesson-progress`, {
    method: "POST",
    headers: { "Content-Type": "application/json", ...authHeaders() },
    body: JSON.stringify(payload),
  });
  if (!res.ok) throw new Error(`http_${res.status}`);
  return res.json();
}

/* ========== Modules ========== */
export async function listModules() {
  const lang = getCurrentLanguage(); // <- NEU: Hole aktuelle Sprache
  const res = await fetch(`${API_BASE}/modules?lang=${lang}`, { // <- NEU: lang Parameter
    headers: { ...authHeaders() },
  });
  if (!res.ok) throw new Error(`http_${res.status}`);
  return res.json();
}

export async function getModule(moduleId) {
  const lang = getCurrentLanguage(); // <- NEU: Hole aktuelle Sprache
  const url = `${API_BASE}/modules/${encodeURIComponent(moduleId)}?lang=${lang}`; // <- NEU: lang Parameter
  console.log("getModule -> fetching", url);

  const res = await fetch(url, { headers: { ...authHeaders() } });

  const text = await res.text();
  console.log(
    "getModule raw response:",
    res.status,
    text.slice(0, 200)
  );

  if (!res.ok) {
    try {
      const data = JSON.parse(text);
      throw new Error(data.error || `http_${res.status}`);
    } catch {
      throw new Error(`http_${res.status}`);
    }
  }

  return JSON.parse(text);
}

export async function getModuleQuiz(moduleId, lessonId) {
  const lang = getCurrentLanguage(); // <- NEU: Hole aktuelle Sprache
  const res = await fetch(
    `${API_BASE}/module-quiz?module_id=${encodeURIComponent(moduleId)}&lesson_id=${encodeURIComponent(lessonId)}&lang=${lang}`, // <- NEU: lang Parameter
    { headers: { ...authHeaders() } }
  );
  if (!res.ok) throw new Error(`http_${res.status}`);
  return res.json();
}

/* ========== Quizzes ========== */
export async function getQuizzes() {
  const res = await fetch(`${API_BASE}/quizzes`, {
    headers: { ...authHeaders() },
  });
  if (!res.ok) throw new Error(`http_${res.status}`);
  return res.json();
}

export async function getQuizQuestions(quizId) {
  const res = await fetch(
    `${API_BASE}/quiz-questions?quiz_id=${encodeURIComponent(quizId)}`,
    { headers: { ...authHeaders() } }
  );
  if (!res.ok) throw new Error(`http_${res.status}`);
  return res.json();
}

export async function createQuizResult(payload) {
  const res = await fetch(`${API_BASE}/quiz-results`, {
    method: "POST",
    headers: { "Content-Type": "application/json", ...authHeaders() },
    body: JSON.stringify(payload),
  });
  if (!res.ok) throw new Error(`http_${res.status}`);
  return res.json();
}

export async function getQuizResults(userId) {
  const res = await fetch(
    `${API_BASE}/quiz-results?user_id=${encodeURIComponent(userId)}`,
    { headers: { ...authHeaders() } }
  );
  if (!res.ok) throw new Error(`http_${res.status}`);
  return res.json();
}

/* ========== Teacher ========== */
export async function getStudentsBySchool(schoolName) {
  const res = await fetch(
    `${API_BASE}/students?school_name=${encodeURIComponent(schoolName)}`,
    { headers: { ...authHeaders() } }
  );
  if (!res.ok) throw new Error(`http_${res.status}`);
  return res.json();
}

export async function getClassResults(schoolName) {
  const res = await fetch(
    `${API_BASE}/class-results?school_name=${encodeURIComponent(schoolName)}`,
    { headers: { ...authHeaders() } }
  );
  if (!res.ok) throw new Error(`http_${res.status}`);
  return res.json();
}

export async function getMyQuizzesByEmail(email) {
  const res = await fetch(
    `${API_BASE}/my-quizzes?created_by=${encodeURIComponent(email)}`,
    { headers: { ...authHeaders() } }
  );
  if (!res.ok) throw new Error(`http_${res.status}`);
  return res.json();
}

/* ========== Auth/Registration ========== */
export async function validateActivationCode(code) {
  const res = await fetch(
    `${API_BASE}/activation/validate?code=${encodeURIComponent(code)}`,
    { headers: { ...authHeaders() } }
  );
  if (!res.ok) throw new Error(`http_${res.status}`);
  return res.json();
}

export async function registerStudent(payload) {
  const res = await fetch(`${API_BASE}/auth/register`, {
    method: "POST",
    headers: { "Content-Type": "application/json", ...authHeaders() },
    body: JSON.stringify(payload),
  });
  if (!res.ok) throw new Error(`http_${res.status}`);
  return res.json();
}

export async function login(email, password) {
  const res = await fetch(`${API_BASE}/auth/login`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ email, password }),
  });
  if (!res.ok) throw new Error(`http_${res.status}`);
  return res.json();
}

/* ========== AI ========== */
export async function aiChat(messages, systemPrompt, maxTokens = 1500, stream = true) {
  const lang = getCurrentLanguage();
  console.log('aiChat() called with lang:', lang);
  const res = await fetch(`${API_BASE}/ai/chat`, {
    method: "POST",
    headers: { 
      "Content-Type": "application/json",
      ...authHeaders()
    },
    body: JSON.stringify({ messages, systemPrompt, maxTokens, stream, lang }),
  });
  if (!res.ok) {
    const error = await res.json().catch(() => ({ error: `http_${res.status}` }));
    throw new Error(error.error || `http_${res.status}`);
  }
  return stream ? res.body : res.json();
}

export async function aiFeedback(question, userAnswer, correctAnswer, systemPrompt) {
  const lang = getCurrentLanguage();
  const res = await fetch(`${API_BASE}/ai/feedback`, {
    method: "POST",
    headers: { 
      "Content-Type": "application/json",
      ...authHeaders()
    },
    body: JSON.stringify({ question, userAnswer, correctAnswer, systemPrompt, lang }),
  });
  if (!res.ok) {
    const error = await res.json().catch(() => ({ error: `http_${res.status}` }));
    throw new Error(error.error || `http_${res.status}`);
  }
  return res.json();
}
   
